var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187141",
    "data-name": "Group 187141",
    transform: "translate(-297 -372)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154451",
    "data-name": "Rectangle 154451",
    width: 46,
    height: 46,
    rx: 8,
    transform: "translate(297 372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grid",
    transform: "translate(279 354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16084",
    "data-name": "Path 16084",
    d: "M38.569,39.943H33.375A1.375,1.375,0,0,1,32,38.569V33.375A1.375,1.375,0,0,1,33.375,32h5.194a1.375,1.375,0,0,1,1.375,1.375v5.194A1.375,1.375,0,0,1,38.569,39.943Z",
    transform: "translate(0 0)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16085",
    "data-name": "Path 16085",
    d: "M278.569,39.943h-5.194A1.375,1.375,0,0,1,272,38.569V33.375A1.375,1.375,0,0,1,273.375,32h5.194a1.375,1.375,0,0,1,1.375,1.375v5.194A1.375,1.375,0,0,1,278.569,39.943Z",
    transform: "translate(-229.906 0)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16086",
    "data-name": "Path 16086",
    d: "M38.569,279.943H33.375A1.375,1.375,0,0,1,32,278.569v-5.194A1.375,1.375,0,0,1,33.375,272h5.194a1.375,1.375,0,0,1,1.375,1.375v5.194A1.375,1.375,0,0,1,38.569,279.943Z",
    transform: "translate(0 -229.906)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16087",
    "data-name": "Path 16087",
    d: "M278.569,279.943h-5.194A1.375,1.375,0,0,1,272,278.569v-5.194A1.375,1.375,0,0,1,273.375,272h5.194a1.375,1.375,0,0,1,1.375,1.375v5.194A1.375,1.375,0,0,1,278.569,279.943Z",
    transform: "translate(-229.906 -229.906)",
    fill: "#8e8e8e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.e6bcb80f68931dbf5a83fd30179a2d82.svg";
export { ForwardRef as ReactComponent };